import {addQueryParams} from "@commons/utils/APIParams";
import {config} from "@commons/config.instance";
import axios from "axios";
import {ValoreAccumuloRecord} from "@commons/mapping/ValoreAccumuloRecord";

export interface ValoreAccumuloParams {
    idAzienda: number,
    idDip: number,
    codAccumulo: string,
    dataIniziale: string, // aaaammgg
    dataFinale: string, // aaaammgg
    dataInizioPeriodo: string, // aaaammgg
    dataFinePeriodo: string, // aaaammgg,
    token?: string,
}

/**
 * es. https://fpnet2.ericed.it/FPNet2021/azienda/67/accumulo/CHKTK?idDip=95518&dataIniziale=20230101&dataFinale=20231231&auth_token=87b5272b1a8bb933e7326002bdd76fc2&nowId=1690466106969&dataFinePeriodo=20230903&dataInizioPeriodo=20230731
 * @param params
 */
export const getValoreAccumuloXDip = (params: ValoreAccumuloParams) => {
    const queryParams: string[] = [];//addBaseQueryParams(params);
    queryParams.push(`idDip=${params.idDip}`);
    queryParams.push(`dataIniziale=${params.dataIniziale}`);
    queryParams.push(`dataFinale=${params.dataFinale}`);
    queryParams.push(`dataInizioPeriodo=${params.dataInizioPeriodo}`);
    queryParams.push(`dataFinePeriodo=${params.dataFinePeriodo}`);
    if (params.token)
        queryParams.push(`auth_token=${params.token}`);
    //if (params.dataIniziale) queryParams.push('dataIniziale=' + moment(params.dataIniziale).format('YYYYMMDD'))
    //if (params.dataFinale) queryParams.push('dataFinale=' + moment(params.dataFinale).format('YYYYMMDD'))
    const url = config.getBaseUrl('FPNet') + `/azienda/${params.idAzienda}/accumulo/${params.codAccumulo}?${addQueryParams(queryParams)}`
    return axios<ValoreAccumuloRecord>(url).then(res => res.data)
}
